import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import ScrollBar from "react-perfect-scrollbar";

//
import { Button, Dropdown } from "react-bootstrap";

//
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
const moment = extendMoment(originalMoment);

function TimeRangeDropdown({
  windowSize,
  title,
  icon,
  filters,
  activeFilter,
  action,
  fit = false,
  full = false,
  align = "end",
  isInvalid = false,
}) {
  const today = moment();
  const [open, setOpen] = useState(false);

  const onSelect = (val) => {
    action({
      name: "custom",
      value: val,
    });
  };

  const setTime = (item) => {
    setOpen(false);

    action({
      name: item.name,
      value: moment.range(
        today.clone().subtract(item.value, "days"),
        today.clone()
      ),
    });
  };

  const renderSelectionValue = () => {
    return (
      <>
        {activeFilter.value.start.format("YYYY-MM-DD")}
        {" / "}
        {activeFilter.value.end.format("YYYY-MM-DD")}
      </>
    );
  };

  return (
    <Dropdown align={align} id="custom-date">
      <Dropdown.Toggle
        className={`${full ? "full" : ""} ${isInvalid ? "is-invalid" : ""}`}
      >
        {icon && <i className={icon}></i>}

        {title && <span className="title">{title} :</span>}
        {activeFilter.value ? (
          <span>{renderSelectionValue()}</span>
        ) : (
          <span className="text-muted">Select one</span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className={fit ? "fit" : ""}>
        <ScrollBar className={windowSize < 768 && !open ? "w-100" : ""}>
          {filters.map((item, index) => (
            <Dropdown.Item
              key={index}
              onClick={() => setTime(item)}
              className={
                activeFilter && item.name === activeFilter.name ? "active" : ""
              }
            >
              {item.name}
            </Dropdown.Item>
          ))}
          <div
            onClick={() => setOpen(true)}
            className="custom-date dropdown-item pointer"
          >
            Custom Date
          </div>
        </ScrollBar>
        {open && (
          <div className="d-flex flex-column">
            <DateRangePicker
              value={activeFilter.value}
              onSelect={onSelect}
              singleDateRange={true}
              numberOfCalendars={windowSize > 1200 ? 2 : 1}
            />
            <Dropdown.Item className="close-btn" onClick={() => setOpen(false)}>
              <Button variant="info">Close</Button>
            </Dropdown.Item>
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

TimeRangeDropdown.propTypes = {
  windowSize: PropTypes.number.isRequired,
  title: PropTypes.string,
  icon: PropTypes.string,
  filters: PropTypes.array.isRequired,
  activeFilter: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  fit: PropTypes.bool,
  full: PropTypes.bool,
  align: PropTypes.string,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(TimeRangeDropdown);
